<template>
	<div class="TimeslotSelect">
		<div class="label-row">
			<v-label class="field-label">{{ $t('text.timeslot') }}</v-label>
			<span v-if="selectedItem" class="tickets-left" :class="{ 'sold-out': selectedItem.free <= 0 }" data-cy="selectedTimeslotTicketsLeft">
				{{ ticketsLeftLabel(selectedItem.free) }}
			</span>
		</div>
		<v-select
			:model-value="modelValue"
			:items="items"
			item-title="title"
			item-value="value"
			variant="outlined"
			density="compact"
			hide-details
			:disabled="disabled || !items.length"
			:placeholder="$t('text.chooseTimeslot')"
			data-cy="timeslotSelect"
			@update:model-value="$emit('update:modelValue', $event)"
		>
			<template #item="{ item, props }">
				<v-list-item v-bind="props" :disabled="item.raw.free <= 0" :data-cy="`timeslot-${item.raw.value}`">
					<template #append>
						<span class="tickets-left" :class="{ 'sold-out': item.raw.free <= 0 }">
							{{ ticketsLeftLabel(item.raw.free) }}
						</span>
					</template>
				</v-list-item>
			</template>
		</v-select>
	</div>
</template>

<script>
import { slotFree } from './rebooking-utils'

export default {
	name: 'TimeslotSelect',
	props: {
		modelValue: String, // 'HH:mm'
		slots: { type: Array, default: () => [] }, // AvailabilitySlot[] of the selected date
		disabled: Boolean,
	},
	computed: {
		items() {
			// a single all-day slot means the product has no timeslots
			const timed = this.slots.filter(slot => slot.time !== '00:00')
			return timed.map(slot => ({
				title: slot.time,
				value: slot.time,
				free: Math.max(slotFree(slot), 0),
			}))
		},
		// persistent count for the currently selected timeslot — without this the count is only
		// visible while the dropdown is open, forcing a re-open (or a trip back to the calendar)
		// to check it again after picking
		selectedItem() {
			return this.items.find(item => item.value === this.modelValue) ?? null
		},
	},
	methods: {
		// the count is rendered here in code rather than via i18n named interpolation — vue-i18n's
		// plural-count argument and named-interpolation argument are mutually exclusive positions,
		// and the translated text may still carry an unresolved '{n}' token, so strip it defensively
		ticketsLeftLabel(count) {
			const text = String(this.$t('text.ticketsLeft', count)).replace(/\{n\}\s*/g, '').trim()
			return `${count} ${text}`
		},
	},
}
</script>

<style scoped>
.label-row { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.field-label { font-size: 13px; margin-bottom: 4px; display: block; }
.tickets-left { font-size: 12px; color: #28500e; white-space: nowrap; }
.tickets-left.sold-out { color: #a8a8a8; }
</style>
